import type { Theme } from "@mui/material";
import { styled } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

import { JobStates } from "../constants";

type Props = {
  value: string;
};

const Root = styled("div")(({ theme }) => ({
  border: "thin solid",
  padding: theme.spacing(0.25),
  borderRadius: 4,
  width: 120,
}));

const defaultStyle = ({ theme }: { theme: Theme }) => ({
  borderColor: theme.palette.text.secondary,
  color: theme.palette.text.secondary,
});

const failedStyle = ({ theme }: { theme: Theme }) => ({
  borderColor: theme.palette.error.main,
  color: theme.palette.error.dark,
  backgroundColor: alpha(theme.palette.error.main, 0.2),
});

const cancelledStyle = ({ theme }: { theme: Theme }) => ({
  borderColor: theme.palette.warning.main,
  color: theme.palette.warning.dark,
  backgroundColor: alpha(theme.palette.warning.main, 0.2),
});

const startingStyle = ({ theme }: { theme: Theme }) => ({
  borderColor: theme.palette.info.main,
  color: theme.palette.info.dark,
  backgroundColor: alpha(theme.palette.info.main, 0.2),
});

const runningStyle = ({ theme }: { theme: Theme }) => ({
  borderColor: theme.palette.info.main,
  color: theme.palette.info.dark,
  backgroundColor: alpha(theme.palette.info.main, 0.2),
});

const StatusIndicator = (props: Props) => {
  const { value } = props;

  const getStatusStyle = (status: string) => {
    switch (status) {
      case JobStates.CANCELLED:
      case JobStates.CANCELLING:
        return cancelledStyle;
      case JobStates.FAILED:
      case JobStates.INTERRUPTED:
        return failedStyle;
      case JobStates.QUEUED:
      case JobStates.QUEUING:
        return startingStyle;
      case JobStates.RUNNING:
        return runningStyle;
      default:
        return defaultStyle;
    }
  };

  const StatusStyled = styled(Root)(getStatusStyle(value));

  return <StatusStyled>{value}</StatusStyled>;
};

export default StatusIndicator;
